module.exports = __webpack_public_path__ + "static/image-eb2c7a900dfa7408fa5b9cde788437af.jpg";